import { SingleAndDiffViewModeSwitcher } from '@/components';
import { useCommentStackSiderView } from '@/features/comment/hooks/stack-sider-view';
import { usePriorIdFromLineage } from '@/features/project/_hooks/project';
import { useProject } from '@/features/project/_hooks/project';
import { useId } from '@/hooks';
import { useProjectPageActiveTabState } from '@/providers';
import { isPS } from '@/utils';
import type { FC } from 'react';
import { useLocation, useNavigate } from 'react-router';

export const ProjectAndDiffSwitcher: FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const activeTab = useProjectPageActiveTabState();
  const { id } = useId();
  const project = useProject(id);

  const priorId = usePriorIdFromLineage({
    params: {
      fiscalYear: project.data?.fiscalYear,
      lineageId: project.data?.lineageId ?? '',
    },
  });

  const targetId = priorId.data?.priorProjectId ?? '';
  const targetProject = useProject(targetId);

  const isDiffPage = location.pathname.endsWith('/diff');

  const stackSiderView = useCommentStackSiderView();

  if (
    project.isLoading ||
    !project.data ||
    !priorId.data?.priorProjectId ||
    (isPS() && (targetProject.isLoading || !targetProject.data))
  ) {
    return null;
  }

  return (
    <SingleAndDiffViewModeSwitcher
      defaultViewMode={isDiffPage ? 'diff' : 'single'}
      onChange={(nextViewMode) => {
        const params = new URLSearchParams(
          Object.fromEntries(
            Object.entries({
              activeKey: activeTab.detail ?? '',
            }).filter(([, value]) => value),
          ),
        );

        if (nextViewMode === 'diff') {
          navigate(
            isPS()
              ? `${location.pathname.replace('/public-site', '')}/diff`
              : `${location.pathname}/diff`,
          );
          stackSiderView.clear();
        } else {
          navigate(`..?${params.toString()}`, { relative: 'path' });
        }
      }}
    />
  );
};
